export const exportAdminReviewsReportApplicationsMutation = `mutation exportAdminReviewsReports($input: ExportRecommendationsReportsInput) {
    exportAdminReviewsReports(input: $input) {
        status
        details
        error {
            message
            date
        }
    }
}`;